export default {"src":"/login-app/[GIT_HASH]/_next/static/media/checkbox_checked.2f5f8763.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};